import { useEffect, useRef } from 'react';
import { renderChart } from '../../utils/chart-renderer';
import type { ContentModalState } from './MessageList.helpers';

interface MessageListContentModalProps {
  state: ContentModalState;
  onClose: () => void;
}

export function MessageListContentModal({
  state,
  onClose,
}: MessageListContentModalProps) {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (state.type === 'chart' && chartRef.current) {
      renderChart(chartRef.current);
    }
  }, [state]);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div
      className="content-modal-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="content-modal">
        <button className="content-modal-close" type="button" onClick={onClose}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        {state.type === 'chart' && state.chartSpec ? (
          <div ref={chartRef} className="chart-container" data-chart-spec={state.chartSpec} />
        ) : state.type === 'table' && state.tableHtml ? (
          <div dangerouslySetInnerHTML={{ __html: state.tableHtml }} />
        ) : state.type === 'image' && state.imageUrl ? (
          <img className="content-modal-image" src={state.imageUrl} alt={state.imageAlt || ''} />
        ) : null}
      </div>
    </div>
  );
}
